import { render, staticRenderFns } from "./DeliveryNote.vue?vue&type=template&id=3910a5a0&scoped=true"
import script from "./DeliveryNote.vue?vue&type=script&lang=js"
export * from "./DeliveryNote.vue?vue&type=script&lang=js"
import style0 from "./DeliveryNote.vue?vue&type=style&index=0&id=3910a5a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3910a5a0",
  null
  
)

export default component.exports